import { Container } from "../components/container";

const BUCKET_BASE_URL = process.env.BUCKET_BASE_URL || "assets";

export function Home() {
  return (
    <Container className="h-dvh pt-[110px] flex flex-col">
      <div
        className="bg-cover bg-top w-full grow max-h-[543px]"
        style={{
          backgroundImage: `url(${BUCKET_BASE_URL}/images/collage.jpg)`,
        }}
      />
    </Container>
  );
}
